module.exports = __webpack_public_path__ + "img/maker_estgroup.e9c7c5cf.jpg";